module.exports = __webpack_public_path__ + "static/media/ecos_Raum_23.a8097f88.jpg";